import React from 'react';
import styled from 'styled-components';

import { useAppDispatch } from './useAppDispatcher.hook';
import { getEmployeeListThunk } from '../redux/Employee/Employee.thunk';
import { Employee } from '../redux/Employee/Employee.type';
import UserBadgeComponent from '../components/UserBadge.component';
import { CANDIDATES_GROUPS } from '../types/candidates.types';

const StyledSelectOption = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const useEmployeeHook = () => {
  const dispatch = useAppDispatch();

  return {
    getSelectList: async (
      search: string,
      loadedOptions: string | any[],
      { group, page }: any,
    ) => {
      const {
        payload: { data, pagination },
      } = await dispatch(
        getEmployeeListThunk({
          group,
          search,
          page,
        }),
      );

      return {
        options: data.map((item: Employee) => ({
          value: item.id,
          label: (
            <StyledSelectOption>
              <UserBadgeComponent info={item} />
            </StyledSelectOption>
          ),
          available: item.available,
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          group,
          page: pagination.current_page + 1,
        },
      };
    },
    getSelectListByIds: async (ids: Array<string>, group?: string) => {
      const {
        payload: { data },
      } = await dispatch(
        getEmployeeListThunk({
          group: { [group || CANDIDATES_GROUPS.ALL]: true },
          ids,
        }),
      );

      return data.map((item: Employee) => ({
        value: item.id,
        label: (
          <StyledSelectOption>
            <UserBadgeComponent info={item} />
          </StyledSelectOption>
        ),
        available: item.available,
      }));
    },
  };
};

export default useEmployeeHook;
